import React, { useState } from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import Form from "../../Reusable/Form/Form.js";
import { UploaderLogicComponent } from "./UploaderLogicComponent.js";
import UppyComponent from "./UppyComponent.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

import "./uploader.scss";

const JumboCodeComponent = () => {
  const { getTextByKey } = useContent();

  const handleSubmit = () => {
    return { message: "", status: "" };
  };

  return (
    <div className="jm-code-zone">
      <div className="info-text">
        This email will be deleted in 7 days. wish to save it for 6 months?
      </div>
      <Form
        fields={{
          JumboCode: {
            fieldKey: "JumboCode",
            element: "input",
            type: "text",
            title: "jubmocode",
            label: "",
            placeholder: "save-code-placeholder",
            validation: {
              required: true,
              reg: /[^\n]+/,
              invalidMessage: "default-input-invalid-message",
            },
          },
        }}
        fieldsProps={{ label: "hidden" }}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("upload-send"),
        }}
      />
      <div className="purshase-codes-container">
        <Icon name="shopping-cart" blue />
        <span>Purchase codes</span>
      </div>
    </div>
  );
};

export const totalSizeENUM = {
  "jm pro": 268435456000,
  "jm business": 322122547200,
  "jm king": 5368709120,
  default: 2147483648,
};

const Uploader = ({
  embedMailId = null,
  setFinishUpload = null,
  embedDesign = null,
}) => {
  const [token, setToken] = useState();
  const [isJMPay, setIsJMPay] = useState(false);
  const [embedFormDetails, setEmbedFormDetails] = useState(null);

  return (
    <UploaderLogicComponent
      setToken={setToken}
      setIsJMPay={setIsJMPay}
      embedMailId={embedMailId}
      setEmbedFormDetails={setEmbedFormDetails}
    >
      <UppyComponent
        {...{
          token,
          isJMPay,
          embedMailId,
          embedFormDetails,
          setFinishUpload,
          embedDesign,
        }}
      />
    </UploaderLogicComponent>
  );
};
export default Uploader;
